import { o2oApi } from 'yxt-biz-pc/packages/api';
import qs from 'qs';

export const getAuditFormInfo = ({ formId, projectId }) => {
  return o2oApi.get(`ojt/audit/form/info?${qs.stringify({ formId, projectId })}`);
};
